import { render } from "./CustomisationItemButton.vue?vue&type=template&id=775b4022&scoped=true"
import script from "./CustomisationItemButton.vue?vue&type=script&lang=js"
export * from "./CustomisationItemButton.vue?vue&type=script&lang=js"

import "./CustomisationItemButton.vue?vue&type=style&index=0&id=775b4022&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-775b4022"]])

export default __exports__